import React from 'react'
import loginimg from './img/login-img.png';
import backarrow from './img/backarrrow.png';
import { Link } from 'react-router-dom';

const RESET_PASSWORD = 'https://dev.sustainabilitypro.io/api/v1/reset-password';

export default function ForgotPassword() {
  return (
    <>
      <div className="container login-container">
        <div className="row">
          <div className="col-md-6 px-0">
            <img src={loginimg} alt="profile_img" />
          </div>
          <div className="col-md-6 login-form forgot-pass">
            <div className='backarrow'>
              <span ><Link to="/"><img src={backarrow} alt="back arrow" /></Link>Forgot Your Password?</span>
              <p>Enter your email, user name, or user ID and we'll email you a new password. The email might take a few minutes to reach your inbox.</p>
            </div>
            <form className="form-custom">
              <label htmlFor="uname">E-mail, User Name, or User ID:<em>*</em></label>
              <div className="input-group">
                <input type="text" className="form-control" name="username" placeholder="Enter Email Id" />
              </div>

              <div className="input-group">
                <Link type="button" className="btn btn-primary btn-lg btn-block">REQUEST PASSWORD</Link>
              </div>

            </form>

          </div>
        </div>
      </div>

    </>
  )
}
